module.exports = __webpack_public_path__ + "static/media/housing-category.520cf7d4.png";